import TextField from '../../../text-field';
import { FilterComponentProps } from '../../types';


export function TextFilter<I extends EntityBase = EntityBase>(props: Pick<FilterComponentProps<I>, 
  'filter' | 'onChange'>) {
  const {
    filter,
    onChange,
  } = props;

  return <TextField 
    id={filter.name.toString()} 
    label={filter.label} 
    value={filter.value as string || ''}   
    onChange={(text) => {
        onChange({
          ...filter,
          value: text
        });
      }}
  />;
}